import React, { useEffect, useState } from 'react';
import { ClipboardList } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import SectionDashboard from '../SectionDashboard';
import { moduleReportTiles } from '@/lib/sectionModules';
import apiClient from '@/services/apiClient';
import { useNavigate } from 'react-router-dom';
import { JoOverdueBanner } from '@/components/processingJo/JoOverdueBanner';
import { JoStuckBanner, STAGE_SETS } from '@/components/processingJo/JoStuckBanner';

const OPERATIONS = [{
  id: 'processing-job-orders',
  title: 'Processing Job Orders',
  description: 'Raise a job order by FG Name — Greige Storage picks the base articles; follow balances & close',
  icon: ClipboardList,
  route: '/sections/processing/job-orders',
  color: 'bg-sky-700'
}];

const ProcessingDashboard = () => {
  const [stats, setStats] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const statsResponse = await apiClient.get('/processing/dashboard/stats');
        setStats(statsResponse.data);
      } catch (error) {
        console.error('Error fetching stats:', error);
      }
    };
    fetchStats();
  }, []);

  // Stats component
  const StatsComponent = stats ? (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      <Card className="bg-white">
        <CardContent className="p-4">
          <p className="text-sm text-gray-500">Pending</p>
          <p className="text-2xl font-bold text-orange-600">{stats.pending_consignments}</p>
        </CardContent>
      </Card>
      <Card className="bg-white">
        <CardContent className="p-4">
          <p className="text-sm text-gray-500">Awaiting Shipment</p>
          <p className="text-2xl font-bold text-blue-600">{stats.awaiting_shipment}</p>
        </CardContent>
      </Card>
      <Card className="bg-white">
        <CardContent className="p-4">
          <p className="text-sm text-gray-500">In Processing</p>
          <p className="text-2xl font-bold text-purple-600">{stats.in_processing}</p>
        </CardContent>
      </Card>
      <Card className="bg-white">
        <CardContent className="p-4">
          <p className="text-sm text-gray-500">Completed Today</p>
          <p className="text-2xl font-bold text-green-600">{stats.completed_today}</p>
        </CardContent>
      </Card>
    </div>
  ) : null;

  return (
    <SectionDashboard
      sectionName="Processing Section"
      sectionId="processing"
      sectionKey="Processing"
      description="Consignments, Transfers & Reports"
      backRoute="/home"
      operations={OPERATIONS}
      utilities={moduleReportTiles('processing')}
      statsComponent={StatsComponent}
      alertComponent={<div className="space-y-3">
        <JoOverdueBanner onView={() => navigate('/sections/processing/job-orders?tab=overdue')} testId="processing-jo-overdue-banner" />
        <JoStuckBanner stages={STAGE_SETS.processing} testId="processing-jo-stuck-banner" />
      </div>}
      notificationBadge={stats?.pending_consignments || 0}
    />
  );
};

export default ProcessingDashboard;
